// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2QRI8","radioRow":"SimpleQuestionBuilderModal_radioRow__366Hf"};